import React from 'react';

export const HumanFactorLogo = ({style}: {style?: Record<string, any>}) => {
  return (
    <div>
      <img style={style} src='/pictures/HFLogo.svg' alt="Human Factor Logo" />
    </div>
  );
};